// HeroSection.jsx
import React from "react";
import "./HeroSection.css";

import rippleVideo from "../Assets/Videos/Ripplerun2026.mp4";
import ripplePoster from "../Assets/images/start.jpg";

const HeroSection = () => {
  const handleJoinClick = () => {
    const registrationSection = document.getElementById("registration-section");

    if (registrationSection) {
      const yOffset = -90;

      const y =
        registrationSection.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="hero">
      {/* Background Video */}
      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
        poster={ripplePoster}
      >
        <source src={rippleVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Hero Content */}
      <div className="hero-content">

        {/* LEFT CONTENT */}
        <div className="hero-left">

          <h1 className="hero-title">
            <span className="hero-highlight">
              Ripple Run
            </span>
            <br />
            One Step. Many Lives.
          </h1>

          <p className="hero-subtitle">
            Take Action Today
          </p>

          <button
            className="hero-button"
            onClick={handleJoinClick}
          >
            Join the Movement
          </button>

        </div>

        {/* RIGHT CARD */}
        <div className="hero-event-card">

          <div className="hero-card-top-line"></div>

          <span className="hero-card-badge">
            NEXT EDITION
          </span>

          <h2 className="hero-card-title">
            Ripple Run
            <br />
            2027
          </h2>

          <h3 className="hero-card-coming">
            Coming Soon
          </h3>

          <p className="hero-card-description">
            Get ready for another unforgettable journey of
            fitness, unity, and impact. Together we will run,
            inspire hope, and transform lives.
          </p>

          <div className="hero-card-footer">
            Stay Connected
          </div>

        </div>

      </div>
    </section>
  );
};

export default HeroSection;